import React from 'react'

import { ContentBack } from './styles'

const BackButton = ({
  goBack,
  withText = true,
  alignment,
}: {
  goBack: () => void
  withText?: boolean
  alignment?: string
}) => {
  return (
    <ContentBack onClick={goBack} $alignment={alignment}>
      <div className="arrow-right-back" />
      {withText && <p>volver</p>}
    </ContentBack>
  )
}

export default BackButton
